import { Pipe, PipeTransform } from '@angular/core';
import { enumPaymentStatus } from '../utils/enum-payment-status';

@Pipe({ name: 'paymentStatus' })
export class PaymentStatusPipe implements PipeTransform {
  transform(id: number, ...args: boolean[]): string {
    switch (id) {
      case enumPaymentStatus.PROCESSING:
        // return `<div class="transfer processing"></div>
        // `;
        return `<span class="text-purple-500 font-medium">In corso</span>
        `;

      case enumPaymentStatus.PAYED:
        //   return `<div class="transfer payed"></div>
        // `;
        return `<span class="text-green-500 font-medium" >Pagato</span>
        `;
      case enumPaymentStatus.NOT_PAYED:
        //     return `<div class="transfer canceled"></div>`;
        // }
        return `<span class="text-orange-600 font-medium">Sospeso</span>`;
    }
    return ``;
  }
}
